import type React from "react";
import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {usePlaylist} from "~/api/hooks/usePlaylist";
import AppHeader from "~/component/common/AppHeader";
import ShareButton from "~/component/common/ShareButton";

import EditPlaylistButton from "../buttons/EditPlaylistButton";
import LevelPreview from "./LevelPreview";

const ViewSinglePlaylist: React.FC = () => {
  const {playlistId} = useParams<{playlistId: string}>();
  const {data: playlistData, error} = usePlaylist({id: playlistId});
  const navigate = useNavigate();

  useEffect(() => {
    if (error) navigate("/play");
  }, [error, navigate]);

  return (
    <div className="flex flex-col w-screen min-h-screen overflow-auto relative text-white bg-transparent">
      <AppHeader title={playlistData?.name} parentPath="/play" />

      <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 z-50 pointer-events-auto">
        <EditPlaylistButton />
        <ShareButton />
      </div>

      <main className="mt-16 px-2 pb-4 flex-1 z-20">
        <div className="flex flex-wrap gap-2 justify-center">
          {playlistData?.levelIds?.map((id: string) => (
            <LevelPreview key={id} levelId={id} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default ViewSinglePlaylist;
